import { Sparkle } from "lucide-react";

const WORDS = ["Sites institucionais", "Landing pages", "Comércios locais", "Catálogos digitais", "Integração com WhatsApp", "Mobile first", "Conexões que geram resultados"];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[#0B0F18] py-7" aria-hidden="true">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center">
          {WORDS.map((w, i) => (
            <span key={w} className="flex items-center">
              <span className={`font-display whitespace-nowrap px-8 text-3xl font-medium sm:text-5xl ${i % 2 ? "text-transparent [-webkit-text-stroke:1px_rgba(0,200,255,0.55)]" : "text-white/90"}`}>{w}</span>
              <Sparkle className="h-6 w-6 shrink-0 text-[#087BFF]" />
            </span>
          ))}
        </div>
      ))}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0B0F18] to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0B0F18] to-transparent" />
  </div>
);
